export const skillScore= [
  { skill: 'Liderazgo', score: 0 },
  { skill: 'Orientación a resultados', score: 0 },
  { skill: 'Aprendizaje continuo', score: 0 },
  { skill: 'Impacto', score: 0 },
  { skill: 'Global Mind', score: 0 },
  { skill: 'Creatividad e Innovación', score: 0 }
];
